import { render, staticRenderFns } from "./ImageColumn.vue?vue&type=template&id=17dbcf94&scoped=true&"
import script from "./ImageColumn.vue?vue&type=script&lang=js&"
export * from "./ImageColumn.vue?vue&type=script&lang=js&"
import style0 from "./ImageColumn.vue?vue&type=style&index=0&id=17dbcf94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dbcf94",
  null
  
)

export default component.exports